import { request } from '@/axios';
import { type ModelDetailsState } from '@/types/model';
import { useUserStore } from '@/store/user';
import { rejectIfNotLogin } from '@/utils/requireLogin';

interface UpdateModelCollectData {
  modelId: number;
  collect: 0 | 1;
}
export function updateModelCollect(data: UpdateModelCollectData) {
  const loginRejected = rejectIfNotLogin();
  if (loginRejected) return loginRejected;

  return request({
    api: '/api/model/collectModelPublish',
    method: 'post',
    data,
    notToast: true
  });
}

export function queryModelDetails(data: {
  id: number;
  share?: boolean; // 是否为团队共享模型
}) {
  const userStore = useUserStore();

  return request<ModelDetailsState>({
    api: userStore.isLogin ? '/api/model/detail' : '/external/externalModelDetail',
    method: 'post',
    data,
    notToast: true
  });
}

// 万能渲染-风格模型列表接口
export interface UniversalRenderingModelLoraItem {
  id: number;
  templateId?: number | null;
  fileName?: string;
  fileUrl?: string | null;
  weight: number;
  sort?: number | null;
  status?: number | null;
  ctime?: string | null;
  utime?: string | null;
}

export interface UniversalRenderingModelItem {
  id: number;
  name: string;
  prompt: string;
  hidePrompt?: string;
  url: string;
  type?: number;
  userModelId?: number;
  loraList?: UniversalRenderingModelLoraItem[];
  /** modelPublishList 数据源的版本列表 */
  verList?: { loraLabel: number; modelId: number; verName: string }[];
  /** 模型的 loraType（Klein / KleinFlux / KleinFlux2） */
  loraType?: string;
  /** 用户在版本下拉中选择的版本 modelId */
  selectedVersionId?: number;
}

export function queryUniversalRenderingModelList() {
  return request<UniversalRenderingModelItem[]>({
    api: '/external/universalRendering/modelList',
    method: 'get',
    notToast: false
  });
}

/**
 * 根据旧版渲染模板 ID 查询对应的新模型 ID 和 styleType
 *
 * 用于历史数据兼容：当 styleType 为 0、1 或空时，说明是旧版数据，
 * 需要通过此接口获取迁移后的 modelId 和 styleType
 */
export interface LegacyStyleMigrationResult {
  modelId: number;
  /** 风格类型: 0-普通, 1-高级, 2-定制, 3-官方普通, 4-官方高级, 5-用户定制 */
  styleType: number;
}

export function queryModelIdByTemplateId(templateId: number) {
  return request<LegacyStyleMigrationResult>({
    api: '/api/renderStyleTemplate/getModelId',
    method: 'post',
    data: { templateId },
    notToast: true
  });
}
